import {ajax,getRequestUrl} from "../request";

export default {
  // 节点管理--三级权限列表
  unlimitPowerList(data, method) {
    return ajax('post', getRequestUrl('/role/editList'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/power.js